<button
  type="button"
  class="pi pi-info-circle text-muted-color ml-1 cursor-pointer text-sm hover:text-red-400"
  [attr.aria-label]="'project.steps.rfi.invitationList.openAnalysis' | transloco"
  (click)="clicked.emit()"
  [attr.data-testid]="testId()"
></button>
